import { render, staticRenderFns } from "./ImproveWindow.vue?vue&type=template&id=6f529b0a"
import script from "./ImproveWindow.vue?vue&type=script&lang=js"
export * from "./ImproveWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports